/* eslint-disable @typescript-eslint/camelcase */
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import React from 'react';
import { EnvironmentAndCeleryQueueStatus } from 'modules/monitor/interfaces';
import AutoCard from 'components/AutoCard';
import StyledTypography from 'components/StyledTypography';
import i18n from 'i18n';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { cyrb53Hash } from 'utils/helpers';
import styles, { overrideCard } from './styles';

const useStyles = makeStyles(styles);

export interface FollowUpCardItem {
  title: string;
  SOPtitle: string;
  value: string | number;
  key: string;
}

interface FollowUpCardProps {
  data: EnvironmentAndCeleryQueueStatus;
}

const FollowUpCard: React.FC<FollowUpCardProps> = ({ data }) => {
  const classes = useStyles();

  const sopData: FollowUpCardItem[] = [
    {
      key: 'total_environments',
      title: i18n.t('MONITOR.ENVIRONMENTS_TOTAL'),
      SOPtitle: i18n.t('ENVIRONMENTS_KEY'),
      value: data?.total_environments,
    },
    {
      key: 'total_instances',
      title: i18n.t('MONITOR.INSTANCES_TOTAL'),
      SOPtitle: i18n.t('INSTANCES_KEY'),
      value: data?.total_instances,
    },
    {
      key: 'total_sessions',
      title: i18n.t('MONITOR.SESSIONS_TOTAL'),
      SOPtitle: i18n.t('SESSIONS_KEY'),
      value: data?.total_sessions,
    },
  ];

  const handleCopy = () => {
    const text = sopData
      .map(item => `${item.SOPtitle}: ${item.value ?? '-'}`)
      .join('\n');

    navigator.clipboard.writeText(text);
  };

  return (
    <AutoCard overrideClasses={overrideCard()}>
      <Grid item xs={10} className={classes.container}>
        {sopData?.map(item => (
          <Grid
            container
            className={classes.item}
            key={cyrb53Hash(`sop-card-content-${item?.key}`)}
          >
            <Typography className={classes.title}>{item?.title}</Typography>
            <StyledTypography value={item?.value} />
          </Grid>
        ))}
      </Grid>
      <Tooltip title={i18n.t('COPY_INFORMATION_KEY')}>
        <IconButton
          className={classes.copyButton}
          onClick={handleCopy}
          size="small"
        >
          <FileCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </AutoCard>
  );
};

const mapStateToProps = ({
  monitor: { environmentAndCeleryQueueStatus },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
  data: environmentAndCeleryQueueStatus,
});

export default connect(mapStateToProps, {})(FollowUpCard);
